export default __webpack_public_path__ + "static/media/Garden-Walls-Angelus-Tango-Block-Project-Tuscan.98323d35.jpg";